import axios from 'config/api';
import {
  USER_LOGGED_IN,
  USER_LOGGED_OUT,
  USER_LOGOUT,
  USER_LOGIN_ERROR,
  USER_LOGIN_SUCCESS,
  USER_REGISTER_ERROR,
  USER_REGISTER_SUCCESS,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_ERROR,
  FETCH_USER_SUCCESS,
  USER_UPDATE_CALENDAR_TOKEN,
} from 'config/constants';

export async function fetchLocalUser() {
  const user = localStorage.getItem('user');

  if (user) {
    return {
      type: USER_LOGGED_IN,
      user: JSON.parse(user),
    };
  }

  return {
    type: USER_LOGGED_OUT,
  };
}

export function userLogin(user) {
  return axios
    .post(`/login`, user)
    .then(response => {
      const { data, status } = response;
      if (status === 200) {
        const { created_at, token, user } = data;
        const loggedUser = {
          created_at,
          ...user,
        };
        localStorage.setItem('user', JSON.stringify(loggedUser));
        localStorage.setItem('token', token);
        return {
          type: USER_LOGIN_SUCCESS,
          user: loggedUser,
        };
      }

      throw new Error();
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      if (data && status === 400) {
        return {
          type: USER_LOGIN_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

export function fetchUserById(id) {
  return axios
    .get(`/user/users/${id}`)
    .then(({ data, status }) => {
      if (status === 200) {
        return {
          type: 'FETCH_USER_SUCCESS',
          categories: data,
        };
      }

      throw new Error();
    })
    .catch(error => {
      console.error('Por favor, entre em contato com o suporte.', error);
      throw error;
    });
}

export async function fetchUsers() {
  return axios
    .get(`/users/`)
    .then(({ data, status }) => {
      if (status === 200) {
        return {
          type: 'FETCH_USER_SUCCESS',
          users: data,
        };
      }

      throw new Error();
    })
    .catch(error => {
      console.error('Por favor, entre em contato com o suporte.', error);
      throw error;
    });
}

export function userRegister(user) {
  return axios
    .post(`/users`, user)
    .then(response => {
      const { data, status } = response;
      console.warn('userRegister', data);
      if (status === 200) {
        console.warn('status', status);
        return {
          type: USER_REGISTER_SUCCESS,
        };
      }

      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      if (data && (status === 400 || status === 403 || status === 422)) {
        return {
          type: USER_REGISTER_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

export function userLogout() {
  localStorage.clear();
  return {
    type: USER_LOGOUT,
  };
}

export function userUpdate(user, id) {
  return axios
    .put(`/user/users/${id}`, user)
    .then(response => {
      const { data, status } = response;
      console.warn('userUpdate', data);
      if (status === 200) {
        console.warn('status', status);
        localStorage.setItem('user', JSON.stringify(data));
        return {
          type: USER_UPDATE_SUCCESS,
          user: data,
        };
      }

      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      if (data && (status === 400 || status === 403 || status === 422)) {
        return {
          type: USER_UPDATE_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

export function userUpdateImage(file, id) {
  const formData = new FormData();

  formData.append('file', file);
  return axios.post(`/user/users/${id}/files`, formData).then(response => {
    const { data, status } = response;
    console.warn('userUpdateImage', data);
    if (status === 200) {
      console.warn('status', status);
      return {
        type: USER_UPDATE_SUCCESS,
        user: data,
      };
    }

    throw response;
  });
}

export function userUpdateCalendarToken(code) {
  return {
    type: USER_UPDATE_CALENDAR_TOKEN,
    code,
    user: {},
  };
}
